import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import Form from '@/common/components/Form';
import Button from '@mui/material/Button';
import { TextInput } from '@/common/components/Inputs';
import styles from '@/modules/general-notes/styles.less';
import NoteDetailsField from '@/modules/general-notes/components/NoteDetailsField';

const NoteForm = ({
  title = '',
  items = [],
  onCancel,
  onSave,
  disableChecklistToggle = false,
  loading = false,
}) => {
  const { t } = useTranslation();

  const initialValues = {
    title,
    checklistItems: items,
    newDetail: '',
  };

  const handleSubmit = (form) => {
    if (!onSave) return;
    onSave({
      title: form.title?.trim(),
      checklistItems: form.checklistItems ?? [],
    });
  };

  return (
    <div className={styles.note}>
      <div className={cx(styles.noteContainer, styles.noteContainerForm)}>
        <Form
          className={styles.noteForm}
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          <TextInput
            name="title"
            label={t('Note title')}
            sx={{ maxWidth: '500px' }}
            required
            disabled={loading}
            inputProps={{ maxLength: 120 }}
            rules={{
              required: t('Enter task name'),
              maxLength: {
                value: 120,
                message: t('Must be shorter than or equal to 120 characters'),
              },
            }}
          />

          <NoteDetailsField
            disableCheckbox={disableChecklistToggle}
            disabled={loading}
          />

          <div className={styles.noteFormActions}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onCancel}
              disabled={loading}
            >
              {t('Cancel')}
            </Button>
            <Button
              type="submit"
              variant="contained"
              color="success"
              disabled={loading}
              loading={loading}
            >
              {loading ? t('Loading...') : t('Save Note')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default NoteForm;
